'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _chemist = require('chemist');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ColorSwatch = require('../ColorSwatch');

var _ColorSwatch2 = _interopRequireDefault(_ColorSwatch);

var _Price = require('../Price');

var _Price2 = _interopRequireDefault(_Price);

var _LineItemQuantity = require('../LineItemQuantity');

var _LineItemQuantity2 = _interopRequireDefault(_LineItemQuantity);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _lineItem = require('../../helpers/lineItem');

var _localisedPaths = require('../../helpers/localisedPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LineItem = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(LineItem, _React$Component);

  function LineItem() {
    (0, _classCallCheck3.default)(this, LineItem);
    return (0, _possibleConstructorReturn3.default)(this, (LineItem.__proto__ || (0, _getPrototypeOf2.default)(LineItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(LineItem, [{
    key: 'variant',
    value: function variant() {
      return this.props.variant;
    }
  }, {
    key: 'render',
    value: function render() {
      var _context;

      var _props = this.props,
          t = _props.t,
          config = _props.config;

      var lng = this.props.params.lng;
      var storeConfig = config.store;


      return _react2.default.createElement(
        'div',
        { styleName: 'lineItem', className: 'clearfix' },
        this.props.errorMessage && _react2.default.createElement(
          'div',
          { styleName: 'lineItemStockError__label' },
          this.props.errorMessage
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'lineItem__details', className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { styleName: 'lineItem__image' },
            _react2.default.createElement('img', {
              alt: this.props.variant.name,
              src: (0, _lineItem.imageUrl)(this.variant())
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'lineItem__detail' },
            _react2.default.createElement(
              'span',
              { styleName: 'lineItem__name' },
              this.props.variant.name
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lineItem__color' },
              _react2.default.createElement(_ColorSwatch2.default, {
                imageUrl: this.props.coveredUrl,
                substrate: this.props.substrate,
                hexRef: (0, _lineItem.hexRef)(this.variant()),
                name: (0, _lineItem.colorOption)(this.variant()).presentation,
                available: (0, _lineItem.hasHexRef)(this.variant())
              })
            ),
            storeConfig.enableNonReadyMixWarning && !this.props.variant.readyMix ? _react2.default.createElement(
              'div',
              { styleName: 'lineItem__mix-item-warning' },
              t('spree.mix_item_warning')
            ) : undefined,
            _react2.default.createElement(
              'span',
              { styleName: 'lineItem__options', className: 'clearfix' },
              (0, _lineItem.sizeOption)(this.variant()).optionTypePresentation,
              ':',
              ' ' + (0, _lineItem.sizeOption)(this.variant()).presentation
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'lineItem__quantity' },
          _react2.default.createElement(
            'div',
            { styleName: 'lineItem__quantitySelect' },
            _react2.default.createElement(_LineItemQuantity2.default, {
              index: this.props.index,
              showInput: this.props.inputType === 'input',
              quantity: this.props.quantity,
              id: this.props.id,
              onChange: (_context = this.props).onChangeQuantity.bind(_context),
              errorMessage: !!this.props.errorMessage
            })
          ),
          _react2.default.createElement(
            'a',
            {
              href: (0, _localisedPaths.localisedAction)(this.props.config.store, 'cart/remove/' + this.props.id, lng),
              className: 'a-link',
              styleName: 'lineItem__remove'
            },
            _react2.default.createElement(
              'span',
              null,
              t('spree.remove')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'lineItem__price' },
          _react2.default.createElement(_Price2.default, { amount: this.props.displayAmount })
        ),
        _react2.default.createElement('input', {
          type: 'hidden',
          value: this.props.id,
          name: 'order[line_items_attributes][' + this.props.index + '][id]'
        })
      );
    }
  }]);
  return LineItem;
}(_react2.default.Component), _class2.propTypes = {
  id: _react.PropTypes.number,
  quantity: _react.PropTypes.number
}, _class2.defaultProps = {
  variant: {},
  onChangeQuantity: function onChangeQuantity() {},
  onClickRemove: function onClickRemove() {}
}, _temp)) || _class) || _class) || _class);
exports.default = LineItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/LineItem/flourish.js
// module id = 2296
// module chunks = 0